$(function () {
  // braintree.checkout.initialize();
});

agnotis.braintree_checkout = (function () {
  var _checkout;
  var clientToken;
  var paypal;
  var $cart;
  var $controls;
  var $labels;
  var $error;

  var init = function (options) {
    paypal = options.paypal;

    $cart = $('form.js-checkout');

    clientToken = $cart.data('braintree-token');
    $controls = $cart.find('button.checkout-loader, [name="payment"]');
    $labels = $cart.find('label');
    $error = $cart.find('.error');

    toggleBraintree();

    // Listen for payment method changes.
    $cart.find('[name="payment"]').change(toggleBraintree);
  };

  /**
   * Toggle the Braintree integration.
   */
  var toggleBraintree = function () {
    // Disable submit
    $controls.prop('disabled', true);
    $labels.addClass('disabled');

    if ($cart.find('#payment_method_nonce').length) {
      $cart.find("#payment_method_nonce").remove();
    };

    if (mustIntegrateBraintree()) {
      $('<input>').attr({
          type: 'hidden',
          id: 'payment_method_nonce',
          name: 'payment_method_nonce'
        })
        .appendTo('form.js-checkout');

      setup();
    } else {
      teardown();
    };
  };

  /**
   * Setup braintree integration.
   */
  var setup = function () {
    if (_checkout) {
      enable();
    } else {
      braintree.dropin.create({
        authorization: clientToken,
        container: '#braintree-form',
        paypal: paypal && {
          flow: 'vault'
        },
        threeDSecure: true,
        locale: 'de_DE',
      }, function (createErr, instance) {
        $button = $cart.find('button.checkout-loader');
        if (createErr) {
          // An error in the create call is likely due to
          // incorrect configuration values or network issues.
          // An appropriate error will be shown in the UI.
          console.error(createErr);

          // Revert the submit button to normal
          removeLoader();

          return;
        } else {
          _checkout = instance;
          enable();
        };

        $button.on("click", function (e) {
          $error.addClass('hidden').empty();

          if ($cart.find('[name="payment"]:checked').val() == 4) {
            e.preventDefault();

            total = $cart.find('.js-checkout-grand-total').data('grand-total');

            customerEmail = $cart.find('[name="email"]').val() || '';
            customerPhone = $cart.find('[name="phone"]').val() || '';
            billingAddressFirstName = $cart.find('[name="first_name"]').val();
            billingAddressLastName = $cart.find('[name="last_name"]').val();
            billingAddressStreet = $cart.find('[name="street"]').val();
            billingAddressCity = $cart.find('[name="city"]').val();
            billingAddressPostalCode = $cart.find('[name="postal_code"]').val();
            billingAddressCountryCode = $cart.find('[name="country"]').val();

            var $braintreeform = $cart.find('.braintree-sheet--active');
            $braintreeform.removeClass('braintree-sheet--has-error');

            instance.requestPaymentMethod({
              threeDSecure: {
                amount: total,
                email: customerEmail,
                // remove (), spaces, and - from phone number;
                mobilePhoneNumber: customerPhone && customerPhone.replace(/[\(\)\s\-]/g, ''),
                billingAddress: {
                  givenName: billingAddressFirstName,
                  surname: billingAddressLastName,
                  // remove (), spaces, and - from phone number;
                  phoneNumber: customerPhone && customerPhone.replace(/[\(\)\s\-]/g, ''),
                  streetAddress: billingAddressStreet,
                  locality: billingAddressCity,
                  postalCode: billingAddressPostalCode,
                  countryCodeAlpha2: billingAddressCountryCode,
                }
              }
            }).then(function (payload) {
              console.log('request payment method', payload);

              if (payload.liabilityShifted || payload.type != "CreditCard") {
                console.log('liability shifted');

                $cart.find("#payment_method_nonce").val(payload.nonce);

                $cart.submit();
              } else {
                console.log('liability did not shift', payload);

                // Revert the submit button to normal
                removeLoader();

                _checkout.clearSelectedPaymentMethod();

                $error.removeClass('hidden')
                  .text('Please select another card or payment method.');
              }

            }).catch(function (requestPaymentMethodErr) {
              console.log('Payment method error');

              // Revert the submit button to normal

              removeLoader();
              console.error(requestPaymentMethodErr);

              $error.removeClass('hidden')
                .text('Please select another card or payment method.');
            });
          }
        });
      });
    }
  };

  /**
   * Teardown an existing braintree integration.
   */
  var teardown = function () {
    // Teardown Braintree if there is an integration
    if (_checkout) {
      _checkout.teardown(function () {
        _checkout = null;
        enable();
      });
    } else {
      enable();
    }
  };

  var removeLoader = function () {
    $button.text($button.data('default'))
      .css({
        'pointer-events': 'auto'
      });
  };

  /**
   * Enable form controls.
   */
  var enable = function () {
    $controls.prop('disabled', false);
    $labels.removeClass('disabled');
    $error.addClass('hidden').empty();
  };

  /**
   * Check if the cart must integrate Braintree.
   */
  var mustIntegrateBraintree = function () {
    return $cart.find('[name="payment"]:checked').val() == 4;
  };

  return {
    initialize: init
  };
})();